// Data layer for the Bill Projection Tool. Every tunable lives here (brief:
// "the data layer is what needs rigor"). Update DATA_LAST_UPDATED whenever a
// value changes — it renders in the results UI.
//
// TODO(bill-projection): named data owner + quarterly update cadence must be
// assigned before launch (brief Section 7). Values marked TODO below are
// blocked on data, access, or human review — do not ship without resolving.

import { ClimateRegion } from '../engine/types';

// ISO date; render through formatBenchmarkDate so readers see a written-out date
export const DATA_LAST_UPDATED = '2026-08-20';

export const PROJECTION_YEARS = 20;

// Spread applied around modeled savings so payback and the 20-year difference
// render as ranges, never point estimates (accuracy-trap mitigation, brief
// Section 6).
// TODO(bill-projection): placeholder bands pending data-owner sign-off.
export const UNCERTAINTY_BAND = 0.2;
// Step 2 (home size + ownership) improves the estimate, so the band tightens.
export const UNCERTAINTY_BAND_REFINED = 0.15;

// Scenario bills never drop below the utility fixed charge. Mirrors
// electrification-calculator engine/assumptions.ts MONTHLY_FIXED_CHARGE_USD.
export const MONTHLY_FIXED_CHARGE_USD = 12;

// National-average installed cost, indexed to installer pricing surveys.
// Mirrors electrification-calculator engine/assumptions.ts SOLAR_USD_PER_WATT.
export const SOLAR_USD_PER_WATT = 2.8;
export const SOLAR_MAX_KW = 12;
export const SOLAR_MIN_KW = 3;

// Post-NEM-3 national stance: 45% of production consumed on site at retail,
// surplus credited at 75% of retail. Mirrors electrification-calculator
// engine/assumptions.ts. TODO(bill-projection): state-level vs national-average
// net-metering model is an open question (brief Section 7) — national average
// overstates savings in post-NEM-3.0 California, Aurora's largest market.
export const SOLAR_EXPORT_RATE_FACTOR = 0.75;
export const SOLAR_SELF_CONSUMPTION_FRACTION = 0.45;

// PVWatts-style annual production per kW-DC by climate region. Mirrors
// electrification-calculator engine/assumptions.ts.
export const solarAnnualKwhPerKwByRegion: Record<ClimateRegion, number> = {
  COLD: 1250,
  HOT_DRY: 1650,
  HOT_HUMID: 1500,
  MARINE: 1150,
  MIXED: 1400,
};

// TODO(bill-projection): state incentive links are blocked on the
// hardcoded-vs-DSIRE decision (brief Section 7 — Legal must weigh in before
// anything is hardcoded). Empty map hides the incentive row in the results UI.
export const stateIncentiveLinks: Record<string, string> = {};

// TODO(bill-projection): community-solar routing for renters is unresolved
// (brief Section 7 — does community solar exist in the current marketplace?).
// Null renders the renter copy without a destination button.
export const COMMUNITY_SOLAR_DESTINATION: string | null = null;

// Required disclosures (brief Section 6) — rendered verbatim in the results UI.
export const DISCLOSURE_ITC =
  'Note: the federal solar tax credit for homeowners expired in December 2025. State programs may apply — check your state.';
export const DISCLOSURE_NET_METERING =
  'Net metering rules vary by utility and significantly affect savings. An installer in your area will know the current rules.';

export const RENTER_COPY =
  'Most solar installations require homeownership, but community solar may be available in your area.';
